import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, UrlTree } from '@angular/router'
import { Observable } from 'rxjs'
import { first, map } from 'rxjs/operators'
import { FeatureService } from './feature.service'

@Injectable({
  providedIn: 'root',
})
export class AdminClusterPlanGuard implements CanActivate {
  constructor(private featureService: FeatureService) {}

  public canActivate(): Observable<boolean | UrlTree> {
    return this.featureService.accessToken$.pipe(
      map((accessToken) => {
        return (
          accessToken.activated.clusterPlan.create ||
          accessToken.activated.clusterPlan.delete ||
          accessToken.activated.clusterPlan.deleteAllClustersOfPlan ||
          accessToken.activated.clusterPlan.migrate ||
          accessToken.activated.clusterPlan.seeAll ||
          accessToken.activated.clusterPlan.type.create ||
          accessToken.activated.clusterPlan.type.delete ||
          accessToken.activated.clusterPlan.type.modify
        )
      }),
      first(),
    )
  }
}
